var quiz = {
    form: function ($this) {
        return $this.closest('.js-quiz-form');
    },

    dataLayer: function ($quizParent, $active, step, action) {
        var currentPageHeading;

        try {
            currentPageHeading = $active.find('.quiz-inner-heading').text() ? $active.find('.quiz-inner-heading').text() : 'Step ' + step;
        } catch (e) {

        }

        var headings = quiz.gatherStepHeadings($quizParent);

        var params = {
            payments: quiz.gatherCheckboxHeading($quizParent, 'payments'),
            os: quiz.gatherCheckboxHeading($quizParent, 'os'),
            bonus: quiz.gatherCheckboxHeading($quizParent, 'bonus'),
            game: quiz.gatherCheckboxHeading($quizParent, 'game'),
        }

        var it = 0;

        dataLayer.push({
            'event': 'GAevent',
            'eventCategory': 'quizStep',
            'eventAction': currentPageHeading + ' - ' + action,
            'eventLabel': headings[it++] + ': ' + params.payments + '; ' + headings[it++] + ': ' + params.os + '; ' + headings[it++] + ': ' + params.bonus + '; ' + headings[it++] + ': ' + params.game
        });
    },

    gatherStepHeadings: function ($quizParent) {
        var headings = [];

        $quizParent.find('.quiz-inner').each(function (it) {
            var heading = $(this).find('.quiz-inner-heading').text() ? $(this).find('.quiz-inner-heading').text() : 'Step ' + it;

            headings.push(heading);
        });

        return headings;
    },

    movePage: function (way, $quizParent) {
        var $active = $quizParent.find('.active');
        var currentStep = parseInt($quizParent.find('.active').data('question-layer'));
        var steps = $quizParent.find('.quiz-inner').length;
        var step = parseInt($active.data('question-layer'));

        if ($active.is('.quiz-result')){
            currentStep = step = ++steps;
        }

        if (window.innerWidth < 768){
            quiz.scroll($quizParent);
        }

        switch (way) {
            case 'next' :

                // Make `prev` button visible if current step bigger than 2
                if (step >= 1) {
                    $quizParent.find('.js-quiz-prev').addClass('visible');
                }

                // Hide `nav` buttons for last ( response ) step
                if (step >= steps) {
                    $quizParent.find('.js-quiz-refresh').addClass('visible');
                    $quizParent.find('.js-quiz-next').removeClass('visible');

                    quiz.callAjax($quizParent);
                }

                // Switch tabs. Hide current step and make visible next step
                $active.removeClass('active').next('.quiz-inner').addClass('active');

                // Change current step size
                $quizParent.find('.js-quiz-current-page').text(currentStep + 1);

                quiz.dataLayer($quizParent, $active, step, 'nextStep');

                return;

            case 'prev' :

                // Hide `prev` button if for first step
                if (step <= 2) {
                    $quizParent.find('.js-quiz-prev').removeClass('visible')
                }

                if (step === steps) {
                    $quizParent.find('.js-quiz-refresh').removeClass('visible');
                    $quizParent.find('.js-quiz-next').addClass('visible');
                }

                // Switch tabs. Hide current step and make visible prev step
                $active.removeClass('active').prev('.quiz-inner').addClass('active')

                // Change current step size
                $quizParent.find('.js-quiz-current-page').text(currentStep - 1);

                quiz.dataLayer($quizParent, $active, step, 'prevStep');

                return;
        }
    },

    resetDefaults: function ($refreshButton) {
        var $form = quiz.form($refreshButton);

        // Reset all element defaults
        $refreshButton.removeClass('visible');
        $form.find('.js-quiz-next').addClass('visible');
        $form.find('.js-quiz-legend').removeClass('invisible');
        $form.find('.js-quiz-result').removeClass('active');
        $form.find('.js-quiz-current-page').text(1);
        $form.find('.js-quiz-prev').removeClass('visible');

        // Clear form fields
        $form[0].reset();

        // Hide all inner tabs except first
        $form.find('.quiz-inner').each(function () {
            $(this).removeClass('active');

            if (1 === parseInt($(this).data('question-layer'))) {
                $(this).addClass('active');
            }
        });
    },

    gatherCheckboxValues: function ($form, key) {
        var output = '';
        var isFirst = true;

        $form.find('input[name="quiz-' + key + '"]:checked').each(function () {
            output += (isFirst ? '' : ', ') + $(this).val();

            isFirst = false;
        });

        return output;
    },

    gatherCheckboxHeading: function ($form, key) {
        var output = '';
        var isFirst = true;

        $form.find('input[name="quiz-' + key + '"]:checked').each(function () {
            output += (isFirst ? '' : ', ') + $(this).data('title');

            isFirst = false;
        });

        return output;
    },

    callAjax: function ($quizParent) {
        var params = {
            payments: quiz.gatherCheckboxValues($quizParent, 'payments'),
            os: quiz.gatherCheckboxValues($quizParent, 'os'),
            bonus: quiz.gatherCheckboxValues($quizParent, 'bonus'),
            game: quiz.gatherCheckboxValues($quizParent, 'game'),
        }

        var data = new FormData();

        data.append('action', 'quiz_complete');
        data.append('params', JSON.stringify(params));
        data.append('layout', $quizParent.data('layout-count'));
        data.append('post', $quizParent.data('post'));

        $.ajax({
            url: localizedScript.url,
            type: 'POST',
            data: data,
            contentType: false,
            processData: false,
            beforeSend: function (xhr) {
                $quizParent.fadeTo(0, 0);
            },
            success: function (data) {
                // Referral handler
                $(document).on('click', '.quiz-app .referral', makeRefHandler());
                $(document).on('click', '.quiz-app .js-casinos-overlay', makeRefHandler({
                    ignoreSelector: 'quiz-toggler'
                }));
                
                // Datalayer
                $(document).on('click', '.quiz-app .referral, .quiz-app .js-casinos-overlay', function (e) {
                    quiz.dataLayer($quizParent, $quizParent.find('.quiz-result'), 'Result', 'clicktoOffer');
                });

                $quizParent.fadeTo(1800, 1);
                $quizParent.find('.quiz-result').addClass('active');
                $quizParent.find('.js-quiz-result-html').html(data);

                $('.js-quiz-toggler').on('click', function () {
                    $(this).hide();

                    $(this).parent().next('.js-quiz-properties').slideToggle();
                });
                if(typeof trackVisibilityElements === 'function'){
                    trackVisibilityElements();
                }
            }
        });
    },

    loadFooterForAll: function () {
        $('.js-quiz-footer').addClass('loaded');
    },
    scroll: function ($element) {
        if ($element.length) {
            let headerHeight = $('header').outerHeight() || 0;
            let targetOffset = $element.offset().top - headerHeight - 10;

            $('html, body').animate({scrollTop: targetOffset}, 1);
        }
    }
}


// Handler for `nav` buttons
$('.js-quiz-next,.js-quiz-prev').on('click', function (event) {
    var $element = $(this);
    var way = event.target.getAttribute('data-way');

    quiz.movePage(way, quiz.form($element));
});


// Handler for `refresh` button
$('.js-quiz-refresh').on('click', function () {
    quiz.resetDefaults($(this));
});


// Init
$(document).ready(function () {
    quiz.loadFooterForAll();
});